exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsmall[data-v-a73e3658] {\n  font-size: 70%;\n}\n.business-card__sm[data-v-a73e3658] {\n  font-size: 0.85rem;\n}\n.cross[data-v-a73e3658] {\n  line-height: 1;\n  font-size: 600%;\n}\ndiv.bCardHover[data-v-a73e3658]:hover{\n  background-color: lightgray!important;\n}\n.circle[data-v-a73e3658] {\n  border: 1px solid #455a64;\n}\n.default-avatar[data-v-a73e3658] {\n  padding-left: 15%;\n  padding-right: 15%;\n  padding-bottom: 15%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a73e3658","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BusinessCard.vue
// module id = GI5L
// module chunks = 1